"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Variant = function () {
  function Variant(name, ratio, value) {
    this.name = name;
    this.ratio = ratio;
    this.value = value;
  }

  return Variant;
}();

exports.default = Variant;
exports.EmptyVariant = new Variant('__undefined__', 1, undefined);